module.exports = __webpack_public_path__ + "0b18f97cf4c9e986a8565943f1176c59.png";